import { useState, useEffect } from "react";
import { userLogin } from "../api/login";
import { authUser } from "../api/auth";
import { forgotPassword } from "../api/userPassword";

export function useLogin({ onLoginSuccess, translate, language }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resetMode, setResetMode] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  useEffect(() => {
    if (!statusMessage) return;
    const timer = setTimeout(() => setStatusMessage(""), 2500);
    return () => clearTimeout(timer);
  }, [statusMessage]);

  useEffect(() => {
    (async () => {
      const data = await authUser();
      if (data?.success) onLoginSuccess();
    })();
  }, [onLoginSuccess]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setShowError(true);
      setTimeout(() => setShowError(false), 2500);
      return;
    }

    setLoading(true);
    try {
        const data = await userLogin(email, password, remember, language);
        if (data?.success) {
            onLoginSuccess(data.user);
        } else if (data?.message === "account_not_active") {
            onLoginSuccess({
                user_id: data.user_id,
                account_status: data.account_status,
            });
        } else {
            const key =
                data?.message === "verify_device"
                    ? "verify_device_message"
                    : data?.message === "user_not_found"
                        ? "user_not_found"
                        : data?.message === "invalid_credentials"
                            ? "invalid_credentials"
                            : "login_failed";

            setStatusMessage(translate(key));
        }

    } catch {
      setStatusMessage(translate("server_error"));
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      const data = await forgotPassword(email, language);
      setStatusMessage(
        data?.success
          ? translate("reset_link_sent")
          : translate("reset_failed")
      );
    } catch {
      setStatusMessage(translate("server_error"));
    } finally {
      setLoading(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    remember,
    setRemember,
    loading,
    resetMode,
    setResetMode,
    statusMessage,
    showError,
    isValidEmail,
    handleSubmit,
    handleReset,
  };
}
